module.exports = __webpack_public_path__ + "static/003-79d98e8cee94191f549aec3bdba74788.jpg";